<mat-card>
  <h2 translate>digitalSignature.title</h2>
  <p translate>digitalSignature.subtitle</p>
  <form [formGroup]="digitalSignatureForm">
    <mat-grid-list cols="16" rowHeight="90px">
      <!-- <mat-grid-tile colspan="4">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>digitalSignature.numContract</mat-label>
          <input id="numContract" formControlName="numContract" matInput type="text" maxlength="30" autocomplete="off"/>
        </mat-form-field>
      </mat-grid-tile> -->
      <mat-grid-tile colspan="4">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>digitalSignature.numOperation</mat-label>
          <input
            id="numOperation"
            formControlName="numOperation"
            matInput
            type="text"
            maxlength="30"
            autocomplete="off"
          />
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile colspan="4">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>digitalSignature.GUID</mat-label>
          <input id="guid" formControlName="guid" matInput type="text" maxlength="50" autocomplete="off" />
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile colspan="4">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>digitalSignature.nif</mat-label>
          <input id="nif" formControlName="nif" matInput type="text" maxlength="30" autocomplete="off" />
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile colspan="4">
        <div fxFlex="100" class="btn">
          <button
            id="sendButtonRequest"
            mat-flat-button
            color="accent"
            (click)="viewResults()"
            [disabled]="sendButtonRequestDisabled"
          >
            {{ 'tracingReports.consult' | translate | uppercase }}
          </button>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </form>
</mat-card>

<mat-card *ngIf="hasCalledOnce">
  <!-- HEADER -->
  <div class="panel-request__card-header" fxLayout="row wrap" fxLayoutAlign="space-between center">
    <mat-card-title class="panel-request__card-header--title" translate> tracingReports.results </mat-card-title>
    <div fxFlex fxLayout="row" fxLayoutAlign="start center" fxLayoutAlign.gt-xs="end center" fxLayoutGap="16px">
      <button
        id="btnChangeColumns"
        mat-stroked-button
        color="accent"
        [disabled]="dataSource.data.length === 0"
        (click)="createExcel()"
      >
        <mat-icon class="icon-ic_file_download"></mat-icon>
        <span>{{ 'exportar excel' | uppercase }}</span>
      </button>
      <button
        id="btnexportMacro"
        mat-stroked-button
        color="accent"
        [disabled]="dataSource.data.length === 0"
        (click)="createPdf()"
      >
        <mat-icon class="icon-ic_print"></mat-icon>
        <span>{{ 'imprimir' | uppercase }}</span>
      </button>
    </div>
  </div>
  <mat-card-content>
    <div *ngIf="dataSource.data.length > 0; else noResults" class="table__wrapper">
      <!-- TABLE -->
      <table aria-label="digitalSignature" mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="request">
          <th mat-header-cell *matHeaderCellDef translate>digitalSignature.numberRequest</th>
          <td mat-cell *matCellDef="let element">{{ element.dataWeb.strNumSol }}</td>
        </ng-container>
        <ng-container matColumnDef="version">
          <th mat-header-cell *matHeaderCellDef translate>digitalSignature.version</th>
          <td mat-cell *matCellDef="let element">{{ element.dataWeb.versionSignature }}</td>
        </ng-container>

        <ng-container matColumnDef="nif">
          <th mat-header-cell *matHeaderCellDef translate>digitalSignature.nif</th>
          <td mat-cell *matCellDef="let element">{{ element.dataWeb.legalIdentity_id }}</td>
        </ng-container>
        <ng-container matColumnDef="logaltyDocResult">
          <th mat-header-cell *matHeaderCellDef translate>digitalSignatureDialog.doc_result</th>
          <td mat-cell *matCellDef="let element">
            {{ this.adminStore.getTextStatus(element.dataLogalty?.document_result) }}
          </td>
        </ng-container>
        <ng-container matColumnDef="statusFinalLogalty">
          <th mat-header-cell *matHeaderCellDef translate>digitalSignatureDialog.finalState</th>
          <td mat-cell *matCellDef="let element">{{ element.dataLogalty?.final_state }}</td>
        </ng-container>
        <ng-container matColumnDef="webDocResult">
          <th mat-header-cell *matHeaderCellDef translate>digitalSignatureDialog.doc_result</th>
          <td mat-cell *matCellDef="let element">
            {{ this.adminStore.getTextStatus(element.dataWeb?.document_result) }}
          </td>
        </ng-container>
        <ng-container matColumnDef="statusFinalWeb">
          <th mat-header-cell *matHeaderCellDef translate>digitalSignatureDialog.finalState</th>
          <td mat-cell *matCellDef="let element">{{ element.dataWeb?.final_state }}</td>
        </ng-container>
        <ng-container matColumnDef="statusWebPetition">
          <th mat-header-cell *matHeaderCellDef translate>digitalSignatureDialog.statePetition</th>
          <td mat-cell *matCellDef="let element">
            {{ this.adminStore.getTextStatus(element.dataWeb?.strEstPeticion) }}
          </td>
        </ng-container>
        <ng-container matColumnDef="receptorHost">
          <th mat-header-cell *matHeaderCellDef translate>digitalSignatureDialog.receptor</th>
          <td mat-cell *matCellDef="let element">
            {{ this.adminStore.getTextStatus(element.dataHost?.document_result) }}
          </td>
        </ng-container>
        <ng-container matColumnDef="statusfinalHost">
          <th mat-header-cell *matHeaderCellDef translate>digitalSignatureDialog.finalState</th>
          <td mat-cell *matCellDef="let element">{{ element.dataHost?.final_state }}</td>
        </ng-container>
        <ng-container matColumnDef="statusHostPetition">
          <th mat-header-cell *matHeaderCellDef translate>digitalSignatureDialog.statePetition</th>
          <td mat-cell *matCellDef="let element">
            {{ this.adminStore.getTextStatus(element.dataHost?.strEstPeticion) }}
          </td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef class="mat-header-cell--actions"></th>
          <td mat-cell *matCellDef="let element" class="mat-cell--buttons">
            <button mat-stroked-button class="mat-cell__buttons" (click)="viewRequest(element)">
              <mat-icon [ngClass]="'icon-ic_visibility'"></mat-icon>
            </button>
          </td>
        </ng-container>
        <ng-container matColumnDef="more">
          <th mat-header-cell *matHeaderCellDef class="mat-header-cell--actions" translate>request.more</th>
          <td mat-cell *matCellDef="let element" class="mat-cell--buttons">
            <button
              id="dropRequestMenuPanel"
              mat-icon-button
              [matMenuTriggerFor]="menu"
              class="mat-cell__buttons"
              aria-label="More actions"
              [disabled]="element.cancelOperation === 'N' && element.printCertificate === 'N'"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button *ngIf="element.cancelOperation === 'S'" mat-menu-item (click)="cancelOperationSignature(element)">
                <mat-icon class="icon-ic_delete_scf"></mat-icon>
                <span translate>request.button.delete</span>
              </button>
              <button *ngIf="element.printCertificate === 'S'" mat-menu-item (click)="printCertificate(element)">
                <mat-icon class="icon-ic_print"></mat-icon>
                <span translate>digitalSignature.print</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <ng-container matColumnDef="dades_operation">
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="3" translate>digitalSignatureDialog.dades</th>
        </ng-container>

        <ng-container matColumnDef="status_logalty" class="border-header">
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="2" translate>digitalSignature.statusLogalty</th>
        </ng-container>

        <ng-container matColumnDef="status_web" class="border-header">
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="3" translate>digitalSignature.statusWeb</th>
        </ng-container>

        <ng-container matColumnDef="status_host" class="border-header">
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="3" translate>digitalSignature.statusHost</th>
        </ng-container>

        <ng-container matColumnDef="emptly" class="border-header">
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="2" translate></th>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="['dades_operation', 'status_logalty', 'status_web', 'status_host', 'emptly']"
        ></tr>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
    <ng-template #noResults>
      <div fxLayout="column" fxLayoutAlign="center center">
        <mat-label class="panel-request__label-no-operation" translate>request.noOperations</mat-label>
      </div>
    </ng-template>
  </mat-card-content>
</mat-card>
